<template>
    <div class="gcse-searchresults-only" data-gname="storesearch"></div>
</template>

<script>
export default {


}
</script>

<style>
</style>